var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.7136 16.9375C15.7136 14.236 12.7016 12.04 10.0001 12.04C7.29862 12.04 4.28662 14.236 4.28662 16.9375M10.0001 9.592C10.866 9.592 11.6964 9.24804 12.3086 8.63578C12.9209 8.02352 13.2649 7.19312 13.2649 6.32725C13.2649 5.46138 12.9209 4.63098 12.3086 4.01872C11.6964 3.40646 10.866 3.0625 10.0001 3.0625C9.13426 3.0625 8.30385 3.40646 7.69159 4.01872C7.07934 4.63098 6.73537 5.46138 6.73537 6.32725C6.73537 7.19312 7.07934 8.02352 7.69159 8.63578C8.30385 9.24804 9.13426 9.592 10.0001 9.592Z","stroke":"#36373A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

User.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = User;

User.default = User;
